const MuiTypography = {
	gutterBottom: {
		marginBottom: 5
	}
};

export default MuiTypography;
